import type { ReactNode } from 'react';
import { cn } from '../foundation/cn';
import { TONE_CLASSES, TONE_SOLID_CLASSES, type Tone } from '../foundation/tone';

export interface BadgeProps {
  readonly tone?: Tone;
  readonly variant?: 'soft' | 'solid';
  readonly className?: string;
  readonly children: ReactNode;
}

// Generic pill. Domain badges (Status/Aging/Alert/…) build on top of this.
export function Badge({
  tone = 'neutral',
  variant = 'soft',
  className,
  children,
}: BadgeProps): JSX.Element {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-xs font-medium',
        variant === 'solid' ? TONE_SOLID_CLASSES[tone] : TONE_CLASSES[tone],
        className,
      )}
    >
      {children}
    </span>
  );
}
